import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import { getEnvConfig, getEnvType } from '../envConfig';

// Initialize Amplify for AWS Cognito integration
let amplifyInitialized = false;

export const initializeAmplify = (): void => {
  if (amplifyInitialized) {
    console.debug('Amplify already initialized, skipping...');
    return;
  }

  try {
    console.debug('🚀 Initializing Amplify v6...');
    amplifyInitialized = true;

    // Determine the app based on the current environment
    const envType = getEnvType();
    const isLocalhost = envType.includes('localhost');

    // For localhost, default to 'pms', otherwise detect from URL
    let app: 'pms' | 'portfolioLab' = 'pms';
    if (!isLocalhost) {
      // Simple domain-based detection - can be enhanced later
      if (window.location.hostname.includes('portfoliolab') || window.location.hostname.includes('portfolio-lab')) {
        app = 'portfolioLab';
      }
    }

    const envConfig = getEnvConfig();
    const { cognitoPool: creds, oAuthSettings } = envConfig.authSettings(app);

    console.debug('Initializing Amplify v6 with client id:', creds.clientAppId);

    // Configure Amplify
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: creds.userPoolId,
          userPoolClientId: creds.clientAppId,
          loginWith: {
            oauth: oAuthSettings
              ? {
                  domain: oAuthSettings.domain,
                  scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
                  redirectSignIn: [oAuthSettings.redirectSignIn],
                  redirectSignOut: [oAuthSettings.redirectSignOut],
                  responseType: 'code',
                  // Adding Google provider if needed
                  providers: ['Google'],
                }
              : undefined,
          },
        },
      },
    });

    // Set cookie storage AFTER configuring Amplify
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
      new CookieStorage({
        domain: envConfig.cookieSettings.domain,
        secure: envConfig.cookieSettings.secure,
        sameSite: envConfig.cookieSettings.sameSite,
      })
    );

    console.debug('✅ Amplify v6 configured successfully with cookie storage');
  } catch (error) {
    console.error('Failed to initialize Amplify:', error);
    amplifyInitialized = false;
  }
};

// Note: Call initializeAmplify() explicitly in App.tsx or main layout
